import React, { useEffect, useState } from "react";
import api from "../axiosConfig";
import { getUser } from "../helpers";

const PricelistRowData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = getUser();

  useEffect(() => {
    const fetchData = (filters, user) => {
      setLoading(true);

      api
        .post("/api/getdcpricelist", {
          user: user,
          page: "dc_pricelist",
          //   currencyType: currency,
        })
        .then((response) => {
          setData(response.data || []);
          setLoading(false);
          // console.log(response.data, "DC");
        })
        .catch((error) => {
          console.error("Error fetching DC price list data:", error);
          setError(error);
          setLoading(false);
        });
    };

    fetchData({
      user,
    });
  }, []);

  return { loading, data, error };
};

export default PricelistRowData;
